import { calculateEnergyKcal } from "@/lib/calculateEnergyKcal";
import { calculatePAC } from "@/lib/calculatePAC";
import { roundToNearest } from "@/lib/utils";
import type { IngredientDraft } from "./preparation";
type AlcoholComposition = Pick<
  IngredientDraft,
  "alcoholPct" | "waterPct" | "energyKcal" | "pac" | "pod"
>;

export function calculateAlcoholComposition(
  alcoholPct: number,
): AlcoholComposition {
  const waterPct = 1 - alcoholPct;

  return {
    alcoholPct,
    waterPct,
    energyKcal: roundToNearest(
      calculateEnergyKcal({
        alcoholPct: alcoholPct,
      }),
      0.01,
    ),
    pac: calculatePAC({ alcohol: alcoholPct }),
    pod: 0,
  };
}
